import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';
import firebaseConfig from './firebase-config.js';

// Initialize Firebase (analytics failures must not break the rest of the site)
const app = initializeApp(firebaseConfig);

let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (err) {
    console.warn('Firebase Analytics unavailable:', err);
  }
}

// Analytics helper functions
export const trackEvent = (eventName, parameters = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, parameters);
  }
};

export const trackPageView = (pageName) => {
  trackEvent('page_view', {
    page_title: pageName,
    page_location: window.location.href
  });
};

export const trackButtonClick = (buttonName, location = '') => {
  trackEvent('button_click', {
    button_name: buttonName,
    button_location: location
  });
};

export const trackSurveyClick = () => {
  trackEvent('survey_click', {
    survey_url: 'https://forms.gle/s6BdE5VomvyFBpku9',
    location: 'hero_section'
  });
};

export const trackSocialClick = (platform) => {
  trackEvent('social_click', {
    social_platform: platform,
    location: 'footer'
  });
};

export const trackEventInterest = (eventType) => {
  trackEvent('event_interest', {
    event_type: eventType,
    location: 'events_section'
  });
};
